import { render, staticRenderFns } from "./user-setting.vue?vue&type=template&id=4f8dd58c"
import script from "./user-setting.vue?vue&type=script&lang=js"
export * from "./user-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports